// ============================================================================
// CUSTOM ERROR CLASSES
// ============================================================================

export class CommandError extends Error {
  name = "CommandError"
  constructor(
    message: string,
    public command?: string,
  ) {
    super(message)
  }
}

export class CommandNotFoundError extends CommandError {
  name = "CommandNotFoundError"
  constructor(command: string) {
    super(`Command not found: ${command}`, command)
  }
}

export class CommandUnavailableError extends CommandError {
  name = "CommandUnavailableError"
  constructor(command: string) {
    super(`Command not available: ${command}`, command)
  }
}

export class CommandTimeoutError extends CommandError {
  name = "CommandTimeoutError"
  constructor(command: string, timeout: number) {
    super(`Command timeout: ${command} (${timeout}ms)`, command)
  }
}

export class CommandExecutionError extends CommandError {
  name = "CommandExecutionError"
  cause: Error

  constructor(command: string, originalError: Error) {
    super(
      `Command execution failed: ${command} - ${originalError.message}`,
      command,
    )
    this.cause = originalError
  }
}

// ============================================================================
// ERROR FACTORY
// ============================================================================

export function createCommandError(
  type: string,
  command: string,
  details?: any,
): CommandError {
  switch (type) {
    case "not-found":
      return new CommandNotFoundError(command)
    case "unavailable":
      return new CommandUnavailableError(command)
    case "timeout":
      return new CommandTimeoutError(command, details?.timeout || 0)
    case "execution":
      return new CommandExecutionError(
        command,
        details?.error || new Error("Unknown error"),
      )
    default:
      return new CommandError(`Unknown error type: ${type}`, command)
  }
}
